module.exports = __webpack_public_path__ + "static/media/svg-6.56b6b56e.svg";